import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountSelect", "companySelect", "userSelect"]

  static values = {
    companyOptionsByAccount: Object,
    userOptionsByAccount: Object,
    userOptionsByAccountCompany: Object,
    allCompanyOptions: Array,
    allUserOptions: Array
  }

  connect() {
    this.refreshDependentOptions()
  }

  accountChanged() {
    this.refreshDependentOptions()
  }

  companyChanged() {
    this.refreshUserOptions()
  }

  refreshDependentOptions() {
    this.refreshCompanyOptions()
    this.refreshUserOptions()
  }

  refreshCompanyOptions() {
    const accountId = this.accountSelectTarget.value
    const currentCompanyId = this.companySelectTarget.value

    const companyOptions = accountId
      ? (this.companyOptionsByAccountValue[accountId] || [])
      : this.allCompanyOptionsValue

    this.renderOptions(this.companySelectTarget, companyOptions, currentCompanyId)
  }

  refreshUserOptions() {
    const accountId = this.accountSelectTarget.value
    const companyId = this.companySelectTarget.value
    const currentUserId = this.userSelectTarget.value

    let userOptions = this.allUserOptionsValue

    if (accountId && companyId) {
      userOptions = this.userOptionsByAccountCompanyValue[`${accountId}:${companyId}`] || []
    } else if (accountId) {
      userOptions = this.userOptionsByAccountValue[accountId] || []
    }

    this.renderOptions(this.userSelectTarget, userOptions, currentUserId)
  }

  renderOptions(selectElement, options, selectedValue) {
    const defaultLabel = selectElement.dataset.defaultOptionLabel || "Alle"

    selectElement.innerHTML = ""
    selectElement.appendChild(new Option(defaultLabel, ""))

    options.forEach(([value, label]) => {
      selectElement.appendChild(new Option(label, value))
    })

    const validValues = new Set(options.map(([value]) => value.toString()))
    selectElement.value = selectedValue && validValues.has(selectedValue.toString()) ? selectedValue.toString() : ""
  }
}
